var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TableFilterRow as TableFilterRowView } from '@devexpress/dx-react-grid-bootstrap4';
export const ColumnFilterCell = (_a) => {
    var _b;
    var { tableColumn } = _a, restProps = __rest(_a, ["tableColumn"]);
    if ((_b = tableColumn.column) === null || _b === void 0 ? void 0 : _b.showFilter) {
        return React.createElement(TableFilterRowView.Cell, Object.assign({}, Object.assign(Object.assign({}, restProps), { tableColumn })));
    }
    return React.createElement(React.Fragment, null);
};
//# sourceMappingURL=ColumnFilterCell.js.map